<template>
  <el-dialog
    :title="$t('cityArea.editArea')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="editCityAreaInfo" label-width="120px">
      <el-form-item :label="$t('cityArea.areaName')" required>
        <el-input
          v-model="editCityAreaInfo.areaName"
          :placeholder="$t('cityArea.areaNameRequired')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('cityArea.areaCode')" required>
        <el-input
          v-model="editCityAreaInfo.areaCode"
          disabled
          :placeholder="$t('cityArea.areaCodeRequired')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('cityArea.parent')" required>
        <el-input
          v-model="editCityAreaInfo.parentAreaName"
          disabled
          :placeholder="$t('cityArea.parentRequired')"
        ></el-input>
      </el-form-item>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editCityArea">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateCityArea, listAreas } from '@/api/shop/cityAreaApi'

export default {
  name: 'EditCityArea',
  data() {
    return {
      dialogVisible: false,
      editCityAreaInfo: {
        id: '',
        areaCode: '',
        areaName: '',
        areaLevel: '',
        parentAreaCode: '',
        parentAreaName: '',
        lon: '',
        lat: ''
      }
    }
  },
  methods: {
    open(params) {
      this.editCityAreaInfo = { ...params }
      this.loadEditCityArea()
      this.dialogVisible = true
    },
    handleClose() {
      this.clearEditCityAreaInfo()
    },
    editCityAreaValidate() {
      if (!this.editCityAreaInfo.areaName) {
        this.$message.warning(this.$t('cityArea.areaNameRequired'))
        return false
      }
      return true
    },
    editCityArea() {
      if (!this.editCityAreaValidate()) {
        return
      }

      updateCityArea(this.editCityAreaInfo).then(response => {
        console.log(response)
        this.$message.success(this.$t('cityArea.editSuccess'))
        this.dialogVisible = false
        this.clearEditCityAreaInfo()
        this.$emit('success')
      }).catch(error => {
        console.error('修改地区失败:', error)
        this.$message.error(this.$t('cityArea.editFailed'))
      })
    },
    clearEditCityAreaInfo() {
      this.editCityAreaInfo = {
        id: '',
        areaCode: '',
        areaName: '',
        areaLevel: '',
        parentAreaCode: '',
        parentAreaName: '',
        lon: '',
        lat: ''
      }
    },
    loadEditCityArea() {
      const params = {
        page: 1,
        row: 1,
        id: this.editCityAreaInfo.id
      }
      
      listAreas(params).then(response => {
        const data = response.data
        if (data && data.length > 0) {
          this.editCityAreaInfo = { ...this.editCityAreaInfo, ...data[0] }
        }
      }).catch(error => {
        console.error('获取地区详情失败:', error)
      })
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>